module.exports = __webpack_public_path__ + "img/flag_en.ee3c722d.svg";